import React from 'react'
import { Drawer } from '@mui/material'
import { styled } from '@mui/material/styles'
import {
  DrawerAnchorTypes,
  DrawerVariantTypes,
} from '@common/GlobalDrawer/types'
import { Flex } from '@fundamentals'

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: boolean
}>(() => ({
  flexGrow: 1,
  transition: 'all 0.6s ease',
  maxWidth: '100%',
}))

const flexDirectionAnchor = (anchor: DrawerAnchorTypes) => {
  switch (anchor) {
    case 'left':
      return 'row'
    case 'right':
      return 'row-reverse'
    case 'top':
      return 'column'
    case 'bottom':
      return 'column-reverse'
    default:
      return 'row'
  }
}

type DrawerWrapperProps = {
  open: boolean
  onClose: () => void
  component: React.ReactNode
  anchor?: DrawerAnchorTypes
  variant?: DrawerVariantTypes
  children: React.ReactNode
  transitionDuration?: number
}

export const WithDrawerLayout: React.FC<DrawerWrapperProps> = ({
  children,
  open,
  onClose,
  component,
  anchor = 'right',
  variant = 'temporary',
  transitionDuration = 600,
}) => {
  return (
    <Flex
      flex={1}
      flexDirection={() => flexDirectionAnchor(anchor)}
      overflow='hidden'
    >
      <Drawer
        open={open}
        onClose={onClose}
        ModalProps={{
          keepMounted: false,
        }}
        sx={{
          maxWidth: open ? '100%' : 0,
          transition: `max-width ${transitionDuration}ms ease-in-out`,
          width: 'auto',
          '& .MuiDrawer-paper': {
            position: variant === 'persistent' && 'relative',
            boxSizing: 'border-box',
          },
        }}
        anchor={anchor}
        variant={variant}
        transitionDuration={transitionDuration}
      >
        {component}
      </Drawer>
      <Main open={open} sx={{ overflow: 'auto' }}>
        {children}
      </Main>
    </Flex>
  )
}
